import { Checkbox, FormControlLabel } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { useMapURLParams } from "../../../../../hooks/map/useMapParams";
import { setTransportMonitoringShowNumbers } from "../../../../../stateManagement/reducers/transport/TransportNowSlice";
import { getMatchedMapPageAdditionalLayerConfigs } from "../../../mapFeatures/layers";

export default function TransportNowOverlay() {
    const dispatch = useDispatch();
    const location = useLocation();
    const { mapName, mapOption } = useMapURLParams();
    const currentConfig = getItemWebStorage('currentConfig');

    const transportMonitoringShowNumbers = useAppSelector(state => state.transportNow.transportMonitoringShowNumbers);
    const matchedConfigs = getMatchedMapPageAdditionalLayerConfigs(currentConfig, {
        mapName,
        mapOption,
        pathname: location.pathname
    });
    const hasConfiguredLegend = matchedConfigs.some((pageConfig: any) => {
        const configuredLayers = Array.isArray(pageConfig?.layers) ? pageConfig.layers : [];
        return configuredLayers.some((layer: any) => layer?.visibleByDefault !== false && layer?.legend?.label);
    });

    function onCheckTransportMonitoringShowNumbers(event: any) {
        setItemWebStorage('transportMonitoringShowNumbers', event.target.checked);
        dispatch(setTransportMonitoringShowNumbers(event.target.checked));
    }

    return (
        <div className={`map-overlay map-overlay-transport-now${hasConfiguredLegend ? ' with-configured-legend' : ''}`}>
            <div className="server-state-display">
                <div className="server-status-circle disconnected" />
                EGTS сервер
            </div>
            <div className="show-transport-numbers-display">
                <FormControlLabel
                    className="check-string"
                    key="transportNowNumbers"
                    checked={transportMonitoringShowNumbers}
                    name="transportNowNumbers"
                    onChange={(event: any) => onCheckTransportMonitoringShowNumbers(event)}
                    color="black"
                    control={<Checkbox className="ch-white" style={{ color: 'white' }} />}
                    label="Номера"
                />
            </div>
        </div>
    );
}
